import { render } from "./decoratorComponent.vue?vue&type=template&id=2e48f301&scoped=true"
import script from "./decoratorComponent.vue?vue&type=script&lang=js"
export * from "./decoratorComponent.vue?vue&type=script&lang=js"

import "./decoratorComponent.vue?vue&type=style&index=0&id=2e48f301&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e48f301"]])

export default __exports__